import {titlePharmacyApp, titlePrescriberApp} from "./titleApp";


export function UseTitleApp(t, name, isPharmacy = false) {
    const label = (isPharmacy? titlePharmacyApp(t) : titlePrescriberApp(t))[name] || {};
    return {
        label
    }
}
